import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import useEmployeeCredentials from './hooks/useEmployeeCredentials';
import { login } from './services/repository/authenticationRepository';
import createClient from './services/apollo-client';
import GenericError from './components/organisms/GenericError';

const LayoutWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function AuthenticationProvider({ children }) {
  const { sourceSystem, token } = useEmployeeCredentials();
  const [authenticatedJwtToken, setAuthenticatedJwtToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLogin = async () => {
      try {
        const jwtToken = await login(sourceSystem, token);
        if (jwtToken) {
          setAuthenticatedJwtToken(jwtToken);
        }
      } catch (e) {
        // do-nothing
      } finally {
        setIsLoading(false);
      }
    };

    handleLogin();
  }, [sourceSystem, token]);

  if (isLoading) {
    return (
      <LayoutWrapper>
        <Spin size="large" />
      </LayoutWrapper>
    );
  }

  if (authenticatedJwtToken) {
    return (
      <ApolloProvider client={createClient(authenticatedJwtToken)}>
        {children}
      </ApolloProvider>
    );
  }

  return (
    <LayoutWrapper>
      <GenericError>
        <p>
          Desculpe, não conseguimos concluir seu acesso.
          <br />
          Por favor, verifique se seus dados foram inseridos corretamente
          <br />
          ou entre em contato com a nossa equipe.
        </p>
      </GenericError>
    </LayoutWrapper>
  );
}

AuthenticationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthenticationProvider;
